import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        color: theme.colors.text[600],
    },
    activeViewName: {
        color: theme.colors.text[900],
        marginRight: theme.spacing(1),
        textAlign: 'left',
        wordBreak: 'break-word',
    },
    unsavedChangesIndicator: {
        width: 8,
        height: 8,
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(1),
        backgroundColor: theme.colors.warning.main,
        borderRadius: '100%',
    },
}));
//# sourceMappingURL=ChipContent.styles.js.map